import { NzLocale } from '../nz-locale.class';

export const trTR: NzLocale = {
  locale: 'tr-TR',

  Pagination: {
    itemsPerPage: '%num% / sayfa',
    jumpTo: 'Goto',
    page: '',
    forwardPage: '%num% sayfa ileri',
    backwardPage: '%num% sayfa geri',
    prevPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    firstPage: 'İlk Sayfa',
    lastPage: 'Son sayfa: %page%',
    totalItems: '%total% öğe',
  },

  DateTime: {
    clear: 'Temiz',
    chooseMonth: 'Bir ay seçin',
    chooseYear: 'Bir yıl seçin',
    chooseDecade: 'On Yıl seçin',
    nYear: '%num%',
    nMonth: '%num%',
    nDay: '%num%',
    prevYear: 'Önceki yıl',
    nextYear: 'Sonraki yıl',
    prevMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    prevDecade: 'Önceki on yıl',
    nextDecade: 'Sonraki on yıl',
    chooseTime: 'Saat seçin',
    chooseDate: 'Tarih seçin',
    chooseTimePlease: 'Saat seçin',
    chooseDatePlease: 'Tarih seçin',
    thisMoment: 'Şimdi',
    today: 'Bugün',
    ok: 'Tamam',
  },

  Modal: {
    okText: 'Tamam',
    cancelText: 'İptal',
    understood: 'Anladım',
  },

  Table: {
    emptyText: 'Veri yok',
  },

  Select: {
    notFoundContent: 'Bulunamadı',
  },

  Transfer: {
    titles: ',',
    notFoundContent: 'Bulunamadı',
    searchPlaceholder: 'Burada ara',
    itemUnit: 'öğe',
    itemsUnit: 'öğeler',
  }
};
